import * as XLSX from "xlsx"

/**
 * Table export utilities: CSV and Excel (XLSX).
 */

export interface ExportColumn {
  id: string
  header: string
}

function escapeCsvValue(value: unknown): string {
  const s = value != null && value !== "" ? String(value) : ""
  if (/[,"\n\r]/.test(s)) {
    return '"' + s.replace(/"/g, '""') + '"'
  }
  return s
}

/**
 * Export rows to CSV and trigger download.
 */
export function exportTableToCsv(
  rows: Record<string, unknown>[],
  columns: ExportColumn[],
  filename = "export.csv"
): void {
  const headers = columns.map((c) => escapeCsvValue(c.header))
  const lines = [headers.join(",")]
  for (const row of rows) {
    const cells = columns.map((c) => escapeCsvValue(row[c.id]))
    lines.push(cells.join(","))
  }
  const blob = new Blob(["\uFEFF" + lines.join("\r\n")], { type: "text/csv;charset=utf-8" })
  const url = URL.createObjectURL(blob)
  const a = document.createElement("a")
  a.href = url
  a.download = filename
  a.click()
  URL.revokeObjectURL(url)
}

/**
 * Export rows to Excel (XLSX) and trigger download.
 */
export function exportTableToExcel(
  rows: Record<string, unknown>[],
  columns: ExportColumn[],
  filename = "export.xlsx"
): void {
  const sheetData = rows.map((row) => {
    const obj: Record<string, unknown> = {}
    for (const col of columns) {
      obj[col.header] = row[col.id] ?? ""
    }
    return obj
  })
  const ws = XLSX.utils.json_to_sheet(sheetData)
  const wb = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(wb, ws, "Sheet1")
  XLSX.writeFile(wb, filename)
}
